<template>
  <!-- swiper -->
  <transition name="slide-fade">
    <div class="start" v-if="isShow">
      <!-- <swiper :options="swiperOption">
        <swiper-slide
          class="slide-1"
          v-for="(item,index) in actCard"
          :key="index"
          style="width:0px;"
        >
          <div class="t-card" style=" box-shadow: 0 0 6px #d9d9d9;">
            <div @click="ActDetail(item.id,item)">
              <div class="cardBg">
                <img :src="item.imageUrl" alt />
              </div>
              <div class="contentBg">
                <p class="actTitle">{{item.title}}</p>
                <p class="des">{{item.summary}}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper> -->
      <div class="act" v-for="(item,index) in actCard" :key="index">
        <div @click="ActDetail(item.id,item)">
          <div class="left">
            <img :src="item.imageUrl" />
          </div>
          <div class="right">
            <div class="title">{{item.title}}</div>
            <div class="content">导语：{{item.summary}}</div>
            <p class="date">{{item.createTime*1000 | formatDate}}</p>
          </div>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </transition>
</template>

<script>
// import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  props: ["navID"],
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      actCard: [],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        loop: true
      },
      isShow: true
    };
  },
  watch: {
    navID: {
      handler: function() {
        if (this.navID === 3) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.axios
      .get("/api/consume/Information/PageList", {
        params: {
          Type: 3,
          page: 1,
          rows: 4
        }
      })
      .then(res => {
        this.actCard = res.data.results;
      });
  },
  methods: {
    ActDetail(id, item) {
      this.$router.push({ path: `/newsIndex/activity/${id}.html` });
      sessionStorage.setItem('newsId',id)
    }
  }
};
</script>

<style scoped>

.act {
  margin-left: 30px;
  overflow: hidden;
  padding-top: 34px;
  clear: both;
  padding-right: 30px;
  overflow: hidden;
}
.act .left {
  float: left;
}
.act .right {
  float: left;
  width: 65%;
}
.act .left img {
  width: 240px;
  height: 160px;
  border-radius: 10px;
}
.act .right .title {
  font-size: 26px;
  color: #444444;
  margin-left: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 400px;
  font-weight: normal;
}
.act .right .content {
  font-size: 22px;
  color: #8b8b8b;
  margin-top: 40px;
  margin-left: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  line-height: 32px;
  width: 400px;
}
.act .line {
  color: #e2e2e2;
  height: 2px;
  margin-top: 190px;
}
.act .date {
  color: #e2e2e2;
  font-size: 22px;
  clear: both;
  margin-left: 14px;
  margin-top: 5px;
}
/* .start .cardBg {
  height: 193px;  
  overflow: hidden;
}
.actTitle {
  font-size: 26px;
  color: #444444;
  text-align: left;
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 18px;
  margin-bottom: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
.des {
  font-size: 22px;
  color: #8b8b8b;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
    line-height: 32px;
}
.swiper-container {
  margin: 0 auto;
  margin-top: 16px;
}
.t-card {
  padding: 18px;
  width: 320px !important;
  border-radius: 10px;
}
.swiper-slide {
  text-align: center;
  height: 450px;
  padding-top: 18px;
}
.swiper-slide img {
  width: 300px;
  height: 193px;
}
.contentBg {
  padding: 18px;
} */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(130px);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/Act.vue